import React from 'react';
import RetrieveGroupApplication from '../components/RetrieveGroupApplication';

function RetrieveGroupApplicationPage() {
    return <RetrieveGroupApplication />;
}

export default RetrieveGroupApplicationPage;